<template>
  <div>
    <div v-if="budgetList.length>1" class="budgetList">
      <div v-for="(item,index) in budgetList" :key="index" :style="item.id==chenckBudget.id?' box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);':''" @click="changeBudget(item)">       
        报价{{index+1}}
        <span v-if="item.isTemp!==0" style="font-size:0.12rem">(已保存)</span>
        <span v-else style="font-size:0.12rem;color:#E64A19">(编辑中)</span>&nbsp;
        <span>
          <i style="margin-right: 0.05rem;" class="el-icon-document-copy" @click="copyBudget(item)"></i>
          <i style="margin-right: 0.05rem;" v-if="item.isTemp!==0" class="el-icon-edit-outline" @click="editBudget(item)"></i>
          <i style="margin-right: 0.05rem;" class="el-icon-delete" @click="deleteBudgetMain(item)"></i>
          <span v-if="item.isTemp==0" style="margin-right: 0.05rem;display: inline-block;width: 0.16rem;"></span>
        </span>
        <p style="font-size:0.12rem">{{dateFormatYMDHM(item.updateTime,'-')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlanInfo } from '../../js/function'
import PlanApi from '@/components/Api/PlanApi.js'
export default {
  props:{
    budgetList: {
      type: Array,
      default: () => { return [] }
    },
    chenckBudget: {
      type: Object,
      default: () => { return {} }
    },
  },
  methods:{
    changeBudget(item){
      getPlanInfo(this.$store.state.planId,item.id)
    },
    copyBudget(item){
      this.$confirm('您确认需要复制该方案生成一个新的方案吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetCopy({id:item.id,planId:item.planId}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"复制成功"})
            getPlanInfo(this.$store.state.planId,'')
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    deleteBudgetMain(item){
      this.$confirm('您确认删除该方案吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetRemove({id:item.id,planId:item.planId}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"删除成功"})
            getPlanInfo(this.$store.state.planId,'')
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    editBudget(item){
      this.$confirm('您确认重新编辑该方案吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetEdit({id:item.id,planId:item.planId}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"复制成功"})
            getPlanInfo(this.$store.state.planId,item.id)
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
  }
}
</script>

<style lang="scss" scoped>
.budgetList{
  padding: 0.1rem 0.15rem;
  display: flex;
  flex-wrap: wrap;
  >div{
    padding: 0.05rem 0.1rem;
    border: 1px solid #869AA6;
    color: #869AA6;
    cursor: pointer;
    min-width: 1.8rem;
    max-width: 2.1rem;
  }
}
</style>